export interface IBillingInfo {
    billingAddress?: string;
    billingDistrict?: string;
    billingName?: string;
    billingPhone?: string;
    billingPostcode?: string;
    billingProvince?: string;
    billingSubDistrict?: string;
    customerCompanyBranch?: string;
    customerCompanyName?: string;
    customerEmail?: string;
    customerFirstName?: string;
    customerLastName?: string;
    customerTaxId?: string;
    requestTaxInvoice: boolean;

}

export class BillingInfo implements IBillingInfo {
    billingAddress?: string | undefined;
    billingDistrict?: string | undefined;
    billingName?: string | undefined;
    billingPhone?: string | undefined;
    billingPostcode?: string | undefined;
    billingProvince?: string | undefined;
    billingSubDistrict?: string | undefined;
    customerCompanyBranch?: string | undefined;
    customerCompanyName?: string | undefined;
    customerEmail?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerTaxId?: string | undefined;
    requestTaxInvoice: boolean;
    private _formatedBillingInfo: string;
    public get formatedBillingInfo(): string {
        if (this.customerFirstName) {
            this._formatedBillingInfo += this.customerFirstName + " ";
        }
        if (this.customerLastName) {
            this._formatedBillingInfo += this.customerLastName + " ";
        }
        if (this.customerTaxId) {
            this._formatedBillingInfo += this.customerTaxId + " ";
        }
        if (this.customerCompanyName) {
            this._formatedBillingInfo += this.customerCompanyName + " ";
        }
        if (this.customerCompanyBranch) {
            this._formatedBillingInfo += this.customerCompanyBranch + " ";
        }
        if (this.billingAddress) {
            this._formatedBillingInfo += this.billingAddress + " ";
        }
        if (this.billingSubDistrict) {
            this._formatedBillingInfo += this.billingSubDistrict + " ";
        }
        if (this.billingDistrict) {
            this._formatedBillingInfo += this.billingDistrict + " ";
        }
        if (this.billingProvince) {
            this._formatedBillingInfo += this.billingProvince + " ";
        }
        if (this.billingPostcode) {
            this._formatedBillingInfo += this.billingPostcode + " ";
        }
        if (this.billingPhone) {
            this._formatedBillingInfo += this.billingPhone + " ";
        }
        if (this.customerEmail) {
            this._formatedBillingInfo += this.customerEmail + " ";
        }
        return this._formatedBillingInfo;
    }

    constructor(data: IBillingInfo) {
        this.requestTaxInvoice = data.requestTaxInvoice
        this._formatedBillingInfo = ""
        this.billingAddress = data.billingAddress
        this.billingDistrict = data.billingDistrict
        this.billingName = data.billingName
        this.billingPhone = data.billingPhone
        this.billingPostcode = data.billingPostcode
        this.billingProvince = data.billingProvince
        this.billingSubDistrict = data.billingSubDistrict
        this.customerCompanyBranch = data.customerCompanyBranch
        this.customerCompanyName = data.customerCompanyName
        this.customerEmail = data.customerEmail
        this.customerFirstName = data.customerFirstName
        this.customerLastName = data.customerLastName
        this.customerTaxId = data.customerTaxId
    }

}